import React, { useState } from 'react'

import { Button, Grid } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import { Container, ContentHeader, DriveTour, Page } from 'components'
import { ImSupplierTable } from './components'
import { Filters } from '../components'

import useFilter from 'hooks/useFilter'

import constants from 'constants/index'
import groupStreamlineIcon from 'images/group_streamline_icon.svg'
import useStyles from './styles'

const ThirdPartyManagementQuestionnairesReceived = () => {
  const [openTour, setOpenTour] = useState(false)

  const filter = useFilter()
  const classes = useStyles()

  const handleOpenTour = () => setOpenTour(true)

  return (
    <Page title="Gestão de Fornecedores - Questionários Recebidos">
      <Container maxWidth={false}>
        <ContentHeader title="Questionários Recebidos">
          <Button
            id={
              constants.tours.thirdPartyManagements.STEPS
                .QUESTIONNAIRES_RECEIVED[1]
            }
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
          >
            Tutorial
          </Button>

          <Filters filter={filter} mySuppliers={false} />
        </ContentHeader>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Alert
              severity="info"
              className={classes.alert}
              icon={
                <img
                  src={groupStreamlineIcon}
                  alt=""
                  width={32}
                  height={32}
                  className={classes.alertIcon}
                />
              }
            >
              {constants.thirdPartyManagements.BANNERS.QUESTIONNAIRES_RECEIVED}
            </Alert>
          </Grid>

          <Grid item xs={12}>
            <ImSupplierTable filter={filter} />
          </Grid>
        </Grid>
      </Container>

      <DriveTour
        stepsMatrix={
          constants.tours.thirdPartyManagements.STEPS_OBJECT
            .QUESTIONNAIRES_RECEIVED
        }
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default ThirdPartyManagementQuestionnairesReceived
